import { useNavigate } from "react-router-dom";
import { AdminButton } from "../../../../../SharedComponents/ListView";

export default function NavigateButton({ path, test, children, disabled }) {
  const navigate = useNavigate();

  const handleNavigate = () => navigate(path, { state: test });

  return (
    <AdminButton variant="primary" onClick={handleNavigate} disabled={disabled}>
      {children}
    </AdminButton>
  );
}
